<script setup lang="ts">
import type { Tour } from "~/types/general";
import IconMapPin from "~/assets/icons/iconMapPin.vue";
import IconStar from "~/assets/icons/iconStar.vue";
const { averageRating, reviewCount, fetchTestimony } = useTestimony();

const props = defineProps<{
  tour: Tour;
}>();

const router = useRouter();
const goToTour = (tour: string) => {
  router.push(`/tour/${tour}`);
};

// wishlist
const wishlistStore = useWishlistStore();
const { toggleWishlist } = wishlistStore;
const wishlist = wishlistStore.wishlist;

const isWishlisted = computed(() => {
  // check the slug is in Wishlist array state
  const slug = props.tour.slug;
  // find in array
  return wishlist.includes(slug);
});

// handle rate
onMounted(() => {
  fetchTestimony(props.tour.testimonies);
})
</script>
<template>
  <WishlistButton
    :modelValue="isWishlisted"
    @update:model-value="toggleWishlist(tour.slug)"
    class="absolute top-0 z-40 w-5 h-5 text-gray-600 right-4"
  />
  <div class="relative flex gap-4 mx-4" @click="goToTour(tour.slug)">
    <img
      v-if="tour.photos.length > 0"
      :key="tour.photos[0].path"
      :src="tour.photos[0].path"
      alt=""
      class="h-[200px] w-[150px] rounded-xl object-cover"
    />
    <div class="flex flex-col justify-between">
      <div class="flex justify-between">
        <h5 class="text-xs font-light uppercase">
          {{ tour.activity_type[0].title }} Activity
        </h5>
      </div>
      <!-- TODO: Feature rating -->
      <div class="flex items-baseline">
        <div class="flex gap-1">
            <img v-for="i in 5" :key="i" :src="i <= averageRating ? '/icons/star.svg' : '/images/star_outline.png'"
              alt="star" width="15" />
        </div>
        <span class="ml-2 text-xs text-gray-500">({{ reviewCount }} Reviews)</span>
      </div>
      <h3 class="text-base font-medium leading-6 text-gray-800">
        {{ tour.title }}
      </h3>
      <span class="text-sm text-gray-500"
        >{{ useHour(Number(tour.duration)) }}
      </span>
      <div class="flex items-center gap-1">
        <IconMapPin />
        <span class="text-gray-500">{{ tour.destination.title }}</span>
      </div>

      <div>
        <span class="mr-0.5 font-semibold text-secondary-80 md:font-medium"
          >From US$ {{ tour.prices[tour.prices.length - 1]?.price ?? 0 }}</span
        >
        <sup class="text-gray-500">per person</sup>
      </div>
    </div>
  </div>
</template>
